module.exports = __webpack_public_path__ + "static/media/truck12.10463a83.jpeg";